import twitter from 'twitter-text';

const nativeTrimRight = String.prototype.trimRight;
const nativeTrim = String.prototype.trim;

export function isEqualIgnoreCase(value1, value2) {
  if (!value1 || !value2) {
    return false;
  }

  return value1.toUpperCase() === value2.toUpperCase();
}

function makeString(object) {
  if (object === null) {
    return '';
  }
  return '' + object;
}

function defaultToWhiteSpace(chars) {
  if (chars === null) {
    return '\\s';
  } else if (chars.source) {
    return chars.source;
  } else {
    return '[' + escapeRegExp(chars) + ']';
  }
}

function rightTrim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrimRight) {
    return nativeTrimRight.call(str);
  }
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp(characters + '+$'), '');
}

export function capitalizeFirstLetter(str, lowercaseRest) {
  str = makeString(str);
  let remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();
  return str.charAt(0).toUpperCase() + remainingChars;
}

export function decapitalize(str) {
  str = makeString(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
}

function trim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrim) {
    return nativeTrim.call(str);
  }
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
}

export function camelize(str, decap) {
  str = trim(str).replace(/[-_\s]+(.)?/g, (match, c) => {
    return c ? c.toUpperCase() : '';
  });

  if (decap) {
    return decapitalize(str);
  } else {
    return str;
  }
}

export function prune(str, length, pruneStr) {
  str = makeString(str);
  length = ~~length;
  pruneStr = pruneStr !== undefined ? String(pruneStr) : '...';

  if (str.length <= length) {
    return str;
  }

  let tmpl = c => {
    return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' ';
  };

  let template = str.slice(0, length + 1).replace(/.(?=\W*\w*$)/g, tmpl) || '';

  if (template.slice(template.length - 2).match(/\w\w/)) {
    template = template.replace(/\s*\S+$/, '');
  } else {
    template = rightTrim(template.slice(0, template.length - 1));
  }

  return (template + pruneStr).length > str.length ? str : str.slice(0, template.length) + pruneStr;
}

export function emptyOrNull(s) {
  return !s || s.length === 0;
}

function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[]\/\\])/g, '\\$1');
}

export function slugify(text) {
  text = String(text)
    .replace(/[^-a-zA-Z0-9\s]+/gi, '')
    .replace(/\s/gi, '-');
  return text && text.toLowerCase();
}

export function generateUuid() {
  return 'xxxxxxxx-xxxx-23xx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function stripHtml(html) {
  let tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.innerText || '';
}

export function extractEmailAddress(string = '') {
  let regex = /\S+[a-z0-9]@[a-z0-9.]+/gim;
  let email = string.match(regex);

  return email;
}

export function linkEmails(emailArray = [], text) {
  emailArray &&
    emailArray.forEach(email => {
      text = text.replace(email, `<a href="mailto:${email}">${email}</a>`);
    });

  return text;
}

export function formatDescription(text = '') {
  return text;
}

export function formatDescriptionSafe(text = '') {
  let strippedText = stripHtml(text);
  let linkTwitterHandles = twitter.autoLink(strippedText);
  let extractedEmails = extractEmailAddress(strippedText);
  let textWithLinkedEmails = linkEmails(extractedEmails, linkTwitterHandles);

  return textWithLinkedEmails;
}

export function generateHash(str) {
  let i,
    l,
    hval = 0x811c9dc5;

  for (i = 0, l = str.length; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }

  return ('0000000' + (hval >>> 0).toString(16)).substr(-8);
}
